export const GRID_BREAKPOINTS = {
	default: 3,
	1100: 2,
	750: 1
};
